import moment from "moment-timezone";

export function formatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}
export function formatTime(time) {
  return moment(time).format("h:mm A");
}
export const findValueByName = (data, nameToFind) => {
  if (data && data.length > 0) {
    const result = data.find(item => item.name === nameToFind);
    return result ? result.value : 'N/A';
  } else {
    return 'N/A'
  }

};


export function zformatDate(date) {
  return moment(date).format("DD/MM/YYYY");
}
export function zformatTime(time) {

  const istTime = moment(time).utcOffset("+05:30");

  // console.log(time, "time", istTime.format("h:mm A"));
  return istTime.format("h:mm A");
}
export function zformatDateSubscription(date) {
  return moment(date).format("Do MMMM, YYYY");
}
export function zformatTimeSubscription(time) {

  const istTime = moment(time).utcOffset("+05:30");

  // console.log(time, "time", istTime.format("h:mm A"));
  return istTime.format("h:mm A");
}

export function shareLink(shortCode) {
  var link = `${process.env.REACT_APP_CLIENT_BASE_UR}home?code=${shortCode}`;
  var message="";
  return { text: message, url: link }
}